export { default as ClosedSearchSubHeader } from './ClosedSearchSubHeader';
